export const mapNotifications = (response) => {
    return response.value;
};
